import { GetterTree } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { LangStoreType } from '@/types/store/lang-store.type';

export const getters: GetterTree<LangStoreType, StoreType> = {
  getCurrentLang(state) {
    return state.lang;
  }
};
